import { render, staticRenderFns } from "./addContractType.vue?vue&type=template&id=82b5e5f4&scoped=true"
import script from "./addContractType.vue?vue&type=script&lang=js"
export * from "./addContractType.vue?vue&type=script&lang=js"
import style0 from "./addContractType.vue?vue&type=style&index=0&id=82b5e5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b5e5f4",
  null
  
)

export default component.exports